// @spec AI-STR-010
// Layout route for AI documents - renders child routes via Outlet

import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/ai/documents')({
  component: AIDocumentsLayout,
});

function AIDocumentsLayout() {
  return <Outlet />;
}
